import { AccountApi } from '@/api/account';

export const UserPermissions = {
    Admin: 'Admin'
};

export class AccountService {

    constructor(client, store, router) {        
        this.store = store;        
        this.router = router;
        this.api = new AccountApi(client);
    }    
    
    async login(email, password) {
        const response = await this.api.login(email, password);        
        const jwt = JSON.parse(atob(response.token.token.split('.')[1]));

        var permissions = [];        
        if (jwt.Admin !== null && jwt.Admin !== undefined) {
            permissions.push(UserPermissions.Admin);
        }

        await this.store.dispatch('session/init', {
            customerID: jwt.CustomerID,
            aud: jwt.aud,
            email: jwt.email,
            exp: jwt.exp,
            iss: jwt.iss,
            jti: jwt.jti,
            nameID: jwt.nameid, 
            uniqueName: jwt.unique_name,           
            token: response.token.token,
            permissions: permissions           
        });       
    }    

    async changePassword(email, currentPassword, newPassword) {
        var response = await this.api.changePassword(email, currentPassword, newPassword); 
        return response;
    } 

    async resetPassword(newPassword, confirmPassword, token) {
        const response = await this.api.resetPassword(newPassword, confirmPassword, token); 
        return response;
    } 

    async remindPassword(email) {
        const response = await this.api.remindPassword(email); 
        return response;
    } 

    logout() {
        this.store.dispatch('session/reset');    
        
        if(this.store._actions['hospital/resetState']){
            this.store.dispatch('hospital/resetState');
        }
        if(this.store._actions['system/resetState']){
            this.store.dispatch('system/resetState');
        }
        if(this.store._actions['ticket/resetState']){
            this.store.dispatch('ticket/resetState');
        }
        
        if (!this.router) return;        

        this.router.push({ name: 'Login' });
    }

    get loggedIn() {
        
        return this.store.getters['session/loggedIn'];
    }

    get isAdmin() {
        return this.hasPermission(UserPermissions.Admin);
    }

    hasPermission(permission) {
        return this.store.dispatch('session/hasPermission', permission);
    }

    async deactivateAccount() {
        const response = await this.api.deactivateAccount(); 
        return response;
    } 

}